import { useCallback, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import ManifestGeneralInfo from './general-info';
import ManifestItemsTable from './items-table';
import ManifestLegsTable from './legs-table';
import ManifestPassengersTable from './passengers-table';
import ManifestLegUldTable from './uld-table';

const ManifestDetails = () => {
  const [manifestLegNumber, setManifestLegNumber] = useState<number | null>(
    null
  );
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const manifestNo = searchParams.get('manifest_no');
  const createdBy = searchParams.get('created_by');
  const createdDate = searchParams.get('created_date');

  const updateManifestLegNumber = useCallback((legNumber: number) => {
    setManifestLegNumber(legNumber);
  }, []);

  if (!manifestNo) {
    navigate('/app/warehouse/manifest');
  }

  return (
    <div className='container-fluid my-4 px-5'>
      <div className='d-flex justify-content-between align-items-center'>
        <div className='my-auto'>
          <nav className='my-auto d-flex ' aria-label='breadcrumb'>
            <ol className='breadcrumb my-auto   align-items-center'>
              <li className='breadcrumb-item'>
                <Link className='link-no-style' to={'/app/warehouse/manifest'}>
                  Manifest
                </Link>
              </li>
              <li
                className='breadcrumb-item active'
                aria-current='page'
                id='shipment_id_breadcrummb'
              >
                {manifestNo}
              </li>
            </ol>
          </nav>
          <small className='createdby' id='created_text'>
            Created by <span id='username'>{createdBy}</span> on{' '}
            <span id='created_date'>{createdDate}</span>
          </small>
        </div>

        <div className='d-flex my-auto text-end'>
          {/* <button
            className='p-2 text-white report_btn align-items-center d-flex gap-1'
            style={{ marginRight: 5 }}
            onClick={() => {}}
          >
            <img alt='pdf' src={pdf_icon} />
            <span>Download PDF</span>
          </button> */}
        </div>
      </div>
      {/* General info section */}
      <div className='row mt-4'>
        <div className='col-sm-12 col-md-12 d-flex flex-column'>
          <div className='flex-grow-1 d-flex flex-column'>
            <ManifestGeneralInfo manifestNo={manifestNo as string} />
          </div>
        </div>
      </div>
      {/* Legs Table Section */}
      <div className='row mt-4'>
        <div className='col-sm-12'>
          <ManifestLegsTable
            manifestNo={manifestNo as string}
            updateManifestLegNumber={updateManifestLegNumber}
          />
        </div>
      </div>
      {/* Items Table Section */}
      <div className='row mt-4'>
        <div className='col-sm-12'>
          <ManifestItemsTable
            manifestNo={manifestNo as string}
            manifestLegNumber={manifestLegNumber}
          />
        </div>
      </div>
      {/* ULDs Table Section */}
      <div className='row mt-4'>
        <div className='col-sm-12'>
          <ManifestLegUldTable
            manifestNo={manifestNo as string}
            manifestLegNumber={manifestLegNumber}
          />
        </div>
      </div>
      {/* Passengers Table Section */}
      <div className='row mt-4'>
        <div className='col-sm-12'>
          <ManifestPassengersTable
            manifestNo={manifestNo as string}
            manifestLegNumber={manifestLegNumber}
          />
        </div>
      </div>
    </div>
  );
};

export default ManifestDetails;
